import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseNetworkIcon, ContentWrapper, NetworkIconWrapper } from './styles';
const AssetNetworkIcon = ({ baseUrl, networkIcon, size = '3rem', }) => {
    if (!networkIcon)
        return _jsx(BaseNetworkIcon, { src: baseUrl, size: size });
    return (_jsxs(ContentWrapper, { children: [_jsx(BaseNetworkIcon, { src: baseUrl, size: size }), _jsx(NetworkIconWrapper, { children: networkIcon })] }));
};
export default AssetNetworkIcon;
//# sourceMappingURL=AssetNetworkIcon.js.map